<template>
    <div class="participant-full-profile">
         <div 
            v-if="isEmpty"
            class="empty"
        >
            Информация не заполнена
        </div>
        <div v-else-if="user" class="content">
            <div
                v-if="gender || status"
                class="short-block"
            >
                <div class="block-label">
                    Личные данные
                </div>
                <div v-if="gender" class="row">
                    <span class="row-label">Пол:</span>
                    <span class="row-value">{{ gender }}</span>
                </div>
                <div v-if="status" class="row">
                    <span class="row-label">Статус:</span>
                    <span class="row-value">{{ status }}</span>
                </div>
            </div>
            <div v-if="user.tel || user.regEmail" class="short-block">
                <div class="block-label">
                    Контакты
                </div>
                <div v-if="user.tel" class="row">
                    <span class="row-label">Телефон:</span>
                    <span class="row-value">{{ user.tel }}</span>
                </div>
                <div v-if="user.regEmail" class="row">
                    <span class="row-label">E-mail:</span>
                    <span class="row-value">{{ user.regEmail }}</span>
                </div>
            </div>
            <div v-if="showEducations" class="block">
                <ParticipantEducations
                    :user="user"
                />
            </div>
            <div v-if="showCareers" class="block">
                <ParticipantCareers
                    :user="user"
                />
            </div>
            <div v-if="user.volunteerActivity || user.socialActivity" class="block">
                <div class="block-label">
                    Социальная активность
                </div>
                <div v-if="user.volunteerActivity" class="row">
                    <span class="row-label">Волонтерская программа:</span>
                    <span class="row-value">{{ user.volunteerActivity }}</span>
                </div>
                <div v-if="user.socialActivity" class="row">
                    <span class="row-label">Социальная работа:</span>
                    <span class="row-value">{{ user.socialActivity }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ParticipantEducations from './ParticipantEducations';
import ParticipantCareers from './ParticipantCareers';

import { mapGetters, mapActions } from 'vuex';

const getters = ['dictionaryByType'];
const actions = ['loadDictionaryItems'];

export default {
    name: 'ParticipantFullProfile',

    components: {
        ParticipantEducations,
        ParticipantCareers,
    },

    props: {
        user: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        ...mapGetters(getters),

        isEmpty() {
            return !this.user || !(
                this.gender ||
                this.status ||
                this.user.tel ||
                this.user.regEmail ||
                this.showEducations ||
                this.showCareers ||
                this.user.volunteerActivity || 
                this.user.socialActivity
            );
        },

        gender() {
            if (this.user) {
                if (this.user.gender === true) {
                    return 'мужской';
                } else if (this.user.gender === false) {
                    return 'женский';
                } else {
                    return null;
                }
            }
            return null;
        },

        status() {
            if (this.user && this.user.foreignStatusId) {
                const statusesList = this.dictionaryByType('user_status') || [];
                const status = statusesList.find(el => el.id == this.user.foreignStatusId);
                return status && status.field_value ? status.field_value.toLowerCase() : '';
            }
            return '';
        },

        showEducations() {
            return this.user && this.user.userEducation && this.user.userEducation.length;
        },

        showCareers() {
            return this.user &&
                (this.user.desiredArea ||
                    (!this.user.isNoWorkExperience && this.user.userCareers && this.user.userCareers.length));
        },
    },

    created() {
        this.loadDictionaryItems('user_status');
    },

    methods: {
        ...mapActions(actions),
    },
};
</script>

<style lang="scss">
@import '~@/styles/rem';

.empty {
    font-family: 'Proxima Nova', sans-serif;
    font-weight: 600;
    font-size: rem(18);
    line-height: rem(26);
    color: #98A0A9;

    @include on-mobile {
        font-size: mrem(16);
        line-height: mrem(24);
    }
}

.participant-full-profile {
    .content {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .block,
    .short-block {
        margin: 0 0 rem(32);
    }

    .short-block {
        width: rem(220);
        margin-right: rem(16);

        @include on-mobile {
            width: 100%;
            margin-right: 0;
        }
    }

    .block {
        width: 100%;

        &-label {
            margin: 0 0 rem(16);
            font-family: 'Proxima Nova', sans-serif;
            font-weight: 600;
            font-size: rem(18);
            line-height: rem(26);
            color: #2a2626;

            @include on-mobile {
                font-size: mrem(18);
                line-height: mrem(26);
            }
        }

        &-flex-container {
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: flex-start;

            @include on-mobile {
                display: block;
            }
        }
    }

    .row, .margin-row {
        margin: 0 0 rem(8);

        @include on-mobile {
            margin: 0 0 mrem(8);
        }

        &-label {
            font-family: 'Proxima Nova', sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(24);
            color: #98a0a9;
            white-space: nowrap;

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(24);
            }
        }

        &-value, &-link {
            margin: 0 0 0 rem(4);
            font-family: 'Proxima Nova', sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: rem(16);
            line-height: rem(24);
            color: #2a2626;

            @include on-mobile {
                margin: 0 0 0 mrem(4);
                font-size: mrem(16);
                line-height: mrem(24);
            }
        }

        &-link {
            color: #4663AB;

            &:hover {
                color: #356ED4;
            }
        }
    }

    .margin-row {
        margin: 0 0 rem(24);

        @include on-mobile {
            margin: 0 0 mrem(16);
        }
    }
}
</style>
